import {createTheme} from "@mui/material/styles";
import {brown} from "@mui/material/colors";
import {Palette, PaletteColor, PaletteMode, Theme, SelectProps, SelectClasses} from "@mui/material";
import {OverridesStyleRules} from "@mui/material/styles/overrides";
declare module "@mui/material/styles" {
  interface Palette {
    input: Palette["primary"];
    custom: Palette["primary"];
    gray: Palette["primary"];
    link: Palette["primary"];
  }

  interface PaletteOptions {
    input?: Palette["primary"];

    custom?: PaletteOptions["primary"];
    gray?: PaletteOptions["primary"];
    link?: PaletteOptions["primary"];
  }
}

// interface PaletteCustom {
//   input: PaletteColor;
//   custom: PaletteColor;
//   gray: PaletteColor;
//   link: PaletteColor;
// }

// type CustomPalette = Palette & PaletteCustom;

export const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mode,

    ...(mode === "light"
      ? {
          primary: {
            light: "#58c9d1",
            main: "#5d90c9",
            dark: " #0e4c75",
          },
          secondary: {
            light: "rgb(236, 64, 122)",
            main: "rgb(216, 27, 96)",
            dark: "rgb(100 3 36)",
            contrastText: "#fff",
          },
          error: {
            light: "#e57373",
            main: "#f44336",
            dark: "#d32f2f",
            contrastText: "#fff",
          },
          info: {
            light: "#85c486",
            main: "#52a05a",
            dark: "#38773a",
          },
          success: {
            light: "#7986cb",
            main: "#3f51b5",
            dark: "#283593",
            contrastText: "#fff",
          },
          warning: {
            light: "#dbdce0",
            main: "#9e9e9e",
            dark: "#4f5470",
            contrastText: "#fff",
          },
          input: {
            light: "#e7e7e7",
            main: "#fafafa",
            dark: "#4f5470",
            contrastText: "#fff",
          },
          custom: {
            light: "#f4f4f5",
            main: "#fff",
            dark: "#dbdce0",
            contrastText: "#fff",
          },
          gray: {
            light: "#dbdce0",
            main: "#fff",
            dark: "#f0fafb",
            contrastText: "#fff",
          },
          link: {
            light: "#551a8b",
            main: "#0000ee",
            dark: "#4f5470",
            contrastText: "#fff",
          },
          background: {
            default: "#fff",
            paper: "#f1f2f6",
          },

          text: {
            primary: "rgba(0, 0, 0, 0.87)",
            secondary: "rgba(0, 0, 0, 0.54)",
            disabled: "rgba(0, 0, 0, 0.38)",
          },
        }
      : {
          primary: {
            light: "#58c9d1",
            main: "#bed2e9",
            dark: " #0e4c75",
          },
          secondary: {
            light: "rgb(236, 64, 122)",
            main: "rgb(216, 27, 96)",
            dark: "rgb(100 3 36)",
            contrastText: "#fff",
          },
          error: {
            light: "#e57373",
            main: "#f44336",
            dark: "#d32f2f",
            contrastText: "#fff",
          },
          info: {
            light: "#85c486",
            main: "#52a05a",
            dark: "#38773a",
          },
          success: {
            light: "#7986cb",
            main: "#3f51b5",
            dark: "#283593",
            contrastText: "#fff",
          },
          warning: {
            light: "#dbdce0",
            main: "#7e7e7e",
            dark: "#dbdce0",
            contrastText: "#fff",
          },
          input: {
            light: "#dbdce0",
            main: "#4f4f4f",
            dark: "#4f5470",
            contrastText: "#fff",
          },
          custom: {
            light: "#555555",
            main: "#444444",
            dark: "#262627",
            contrastText: "#fff",
          },
          gray: {
            light: "#555555",
            main: "#444444",
            dark: "#3f3f3f",
            contrastText: "#fff",
          },
          link: {
            light: "#b7a7c6",
            main: "#d0d0fb",
            dark: "#b7a7c6",
            contrastText: "#fff",
          },
          background: {
            default: "#222222",
            paper: "#333333",
          },

          text: {
            primary: "#fff",
            secondary: "rgba(0, 0, 0, 0.54)",
            disabled: "rgba(0, 0, 0, 0.38)",
          },
        }),
  },

  typography: {
    fontFamily: ["Roboto", "pretendard"].join(","),
    fontSize: 14,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: (theme: Theme) => ({
        html: {
          width: "100%",
          height: "100%",
        },
        body: {
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.background.default,
        },

        a: {
          textDecoration: "none",
          color: theme.palette.link.main,
          "&:hover": {
            color: theme.palette.link.dark, // hover 상태
          },
          "&:visited": {
            color: theme.palette.link.light, // visited 상태
          },
          "&:active": {
            color: theme.palette.link.contrastText, // active 상태
          },
        },
        textarea: {
          backgroundColor: theme.palette.input.main,
          color: theme.palette.text.primary,
        },
      }),
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: (props: {theme: Theme}) => ({
          // theme 구조 분해 할당 사용 (옵션)
          // theme.palette.error.main 등을 사용하는 것이 더 일반적입니다.
          color: props.theme.palette.error.main, // "red" 대신 테마 색상 사용 권장
        }),
      },
    },

    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: (props: {theme: Theme}) => ({
          backgroundColor: props.theme.palette.input.main,
          color: props.theme.palette.text.primary,
        }),
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: (props: {theme: Theme}) => ({
          color: props.theme.palette.text.primary,
        }),
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: (props: {theme: Theme; ownerState: SelectProps}) => ({
          backgroundColor: props.theme.palette.input.main,
          color: props.theme.palette.text.primary,
          // 필요한 경우 ownerState를 사용하여 추가 스타일 정의
        }),
        // 필요한 추가 스타일 정의
      } as Partial<
        OverridesStyleRules<keyof SelectClasses, "MuiSelect", Omit<Theme, "components">>
      >,
    },
  },
});
